import { render, staticRenderFns } from "./content-object-details-fire-bottles-equipment.vue?vue&type=template&id=4ec0001c&"
import script from "./content-object-details-fire-bottles-equipment.vue?vue&type=script&lang=js&"
export * from "./content-object-details-fire-bottles-equipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/defaults-i18n.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fweb%2Fsrc%2Fcomponents%2Ftasks%2Fcreate%2Fcontent-object-details-fire-bottles-equipment.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "./content-object-details-fire-bottles-equipment-i18n.yaml?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fweb%2Fsrc%2Fcomponents%2Ftasks%2Fcreate%2Fcontent-object-details-fire-bottles-equipment.vue"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
